import { render, staticRenderFns } from "./act-list.vue?vue&type=template&id=93a62f68&scoped=true&"
import script from "./act-list.vue?vue&type=script&lang=js&"
export * from "./act-list.vue?vue&type=script&lang=js&"
import style0 from "./act-list.vue?vue&type=style&index=0&id=93a62f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a62f68",
  null
  
)

export default component.exports